import {withStylesProvider} from '../..';

import {NumbersContainer, NumbersLeft, NumbersRight} from './Numbers';
import {StylesProvider} from './theme/context';
import {numbersTheme} from './theme/theme';

type NumbersType = typeof NumbersContainer & {
  Container: typeof NumbersContainer;
  Left: typeof NumbersLeft;
  Right: typeof NumbersRight;
};

const Numbers: NumbersType = withStylesProvider(
  NumbersContainer,
  StylesProvider,
  numbersTheme,
) as unknown as NumbersType;

Numbers.Container = NumbersContainer;
Numbers.Left = NumbersLeft;
Numbers.Right = NumbersRight;

export {Numbers, NumbersContainer, NumbersLeft, NumbersRight};
